import { FormField, getErrors, RadioList } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type RadioFieldProps = {
  options: Array<{ label: string; value: string }>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function RadioField(props: RadioFieldProps) {
  const { options, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <RadioList
          variant="outlined"
          value={field.state.value}
          items={options ?? []}
          onChange={field.handleChange}
        />
      }
    />
  );
}
